import React from 'react';
import { Checkbox, colors, FormControlLabel } from '@mui/material';
import { styled } from '@mui/system';

const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
    margin: 0,
    border: 'none',
    padding: 0,
    '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: '#8c8c8c'
    },
    '&.MuiCheckbox-root': {
        borderRadius: 8,
        padding: 0,
    },
    '&.Mui-checked': {
        '& .MuiSvgIcon-root': {
            fill: '#01CB46',
        },
    },
    '&:hover': {
        background: 'transparent',
    },
    '&:focus': {
        outline: 'none',
        background: 'transparent',
    },
}));

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
    margin: 0,
    padding: 0,
}));

const CheckboxComponent = ({ label, checked, onChange, className, clickable = true }) => {
    return (
        <CustomFormControlLabel
            control={
                <CustomCheckbox
                    className={`${className} kg_loyalty-checkbox_wrapper`}
                    checked={checked}
                    onChange={clickable ? onChange : null}
                    disabled={!clickable}
                />
            }
            label={label}
        />
    );
};

export default CheckboxComponent;